export const DEFAULT_NEXT_CHANNEL_PAGE_SIZE = 25;
export const DEFAULT_JUMP_TO_PAGE_SIZE = 25;
export const DEFAULT_THREAD_PAGE_SIZE = 25;
export const DEFAULT_LOAD_PAGE_SCROLL_THRESHOLD = 250;
export const DEFAULT_HIGHLIGHT_DURATION = 500;
